import _ from 'lodash'
import { useEffect, useRef } from 'react'
import { currentPageFlowPhase, singleSendI13nPageViewByPageKey } from '../../../../../lib/i13nUtil'

const useI13N = (i13nMethods, i13nData, pageFlow, formValues) => {
  const { proposalType } = i13nData
  const { sendI13nPageViewByPageKey } = i13nMethods
  const flowRef = useRef(null)

  useEffect(() => {
    const phase = currentPageFlowPhase(pageFlow)
    if (_.isEmpty(phase) || (flowRef.current === phase)) { return }
    flowRef.current = phase
    singleSendI13nPageViewByPageKey(sendI13nPageViewByPageKey, proposalType, phase, formValues)
  }, [sendI13nPageViewByPageKey, pageFlow, proposalType])
}

export default useI13N
